module.exports = __webpack_public_path__ + "img/select08.c74deb36.png";